import { fetchStore } from 'api/Store/actions'
import Modal from 'components/Modal'
import { closeStoreDetails } from 'components/Store/actions'
import StoreDetails from 'components/Store/StoreDetails'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import type { State } from 'store/types'

function StoreDetailsModal() {
  const dispatch = useDispatch()
  const dateCurrent = useSelector((state: State) => state.datePicker.dateCurrent)
  const hideModal = () => dispatch(closeStoreDetails())
  const { countryId, isOpen, storeId } = useSelector((state: State) => state.storeDetails)
  const fetchStoreDetails = (storeId: number) => {
    dispatch(
      fetchStore({
        dateCurrent,
        storeId,
      }),
    )
  }

  if (!isOpen) return null

  return (
    <Modal hideModal={hideModal}>
      <StoreDetails countryId={countryId} fetchStoreDetails={fetchStoreDetails} hideModal={hideModal} storeId={storeId} />
    </Modal>
  )
}

export default StoreDetailsModal
